import { Row } from 'react-bootstrap';
import styled from 'styled-components';

export const LeadsOverlapModalBody = styled(Row)`
  .lead-search-option-container:hover {
    background-color: transparent;
  }
`;
